<template>
    <b-modal title="Aggiungi Nota" ref="mdlRsaDiariNoteEdit" id="mdlRsaDiariNoteEdit" size="lg" @ok="onOk">
        <div class="sa-tab-scroll">
            <div class="sa-flexbox">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Data Ora:</label>
                            <b-input-group class="mb-3">
                                <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOraEsecuzione" type="datetime"></date-picker>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <label class="sa-label-data">Note:</label>
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.annotazione" />
                    <!-- <b-row>
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

					</b-col>
				</b-row> -->
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { VueEditor } from "vue2-editor";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: {
        DatePicker,
        VueEditor,
    },
    data() {
        return {
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],

                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            pathResource: "/rsadiarivoci",
            jsonData: {},
            id: "",
            perPage: 1000000,
        };
    },
    methods: {
        add(jsonData) {
            let me = this;
            me.jsonData = jsonData;
            me.id = "";
            me.$refs.mdlRsaDiariNoteEdit.show();
        },
        modificaNota(id) {
            let me = this;
            me.id = id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + me.id, {}, me.resultResponseLoadData, me.resulErrorLoadData);
        },
        resultResponseLoadData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.dataOraEsecuzione = new Date().getTime();
            me.jsonData.dataOraProgrammata = new Date().getTime();
            me.$refs.mdlRsaDiariNoteEdit.show();
        },
        resulErrorLoadData(error) {
            console.log(error);
        },
        onOk() {
            let me = this;
            if (me.id) {
                me.updateNota();
            } else {
                me.createNota();
            }
        },
        createNota() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .post(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        updateNota() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
            axios
                .put(link, JSON.stringify(me.jsonData))
                .then(() => {
                    me.$emit("afterSaveRequest");
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
    },
};
/*
TOOLBAR STANDARD
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["link", "image", "video"],
                ["clean"], // remove formatting button
            ],

*/
</script>

<style>
.sa-flexbox-body .row {
    flex: 1;
    height: 1px;
}
.sa-flexbox-body .row .col-sm-12.col-md-12.col-lg-12.col-xl-12.col-12 {
    height: 100%;
}
</style>
